/** @flow */

import type { ObjectBall } from "./types";

export const BallValues: { [key: ObjectBall]: { value: number; } } = {
  'RED': { value: 1 },
  'YELLOW': { value: 2 },
  'GREEN': { value: 3 },
  'BROWN': { value: 4 },
  'BLUE': { value: 5 },
  'PINK': { value: 6 },
  'BLACK': { value: 7 },
};



// WEBPACK FOOTER //
// ./src/match/BallValues.js